module.exports = new __parcel__URL__("sky.5616f04b.png").toString();